import React, { Component } from 'react';
import Link from 'gatsby-link'
import MediaQuery from 'react-responsive'

//Components
import SelectLanguage from '../components/SelectLanguageHeader.js'
import SelectLanguageEn from '../components/SelectLanguageEnHeader.js'

//GTM
import { clickLinks } from "../gtm";

class SecondNav extends Component {
  constructor(props) {
    super(props);
  }

  handleGTMclick(link) {
    clickLinks(link);
  }

  render() {
    const animation = this.props.toogleClass ? 'on' : 'off'
    return (
      <nav className="menu second-nav">
        {this.props.langs.map(lang => {
          if (lang.langKey == 'en' && lang.selected) {
            return (
              <ul key={lang.langKey}>
                <li>
                  <SelectLanguage langs={this.props.langs} />
                </li>
                
                <li>
                 <a href="http://www.ventacar.com.ni/" target="_blank"> 
                  Sell cars
                </a>
                </li>
                <li>
                  <Link to={`/${lang.langKey}/faqs`}>Customer Care</Link>
                </li>

                <li>
                <a
                  className="whatsapp"
                  href="https://api.whatsapp.com/send?phone=50588561510"
                >
                  +505 8856-1510
                </a>
              </li>
                <li>
                  <a
                    className="btn btn-rounded phone-number"
                    href="tel:+50522559000"
                    onClick={() => this.handleGTMclick("tel:+50522559000")}
                  >
                    +505 2255-9000
                  </a>
                </li>
              </ul>
            )
          } else if (lang.langKey == 'es' && lang.selected) {
            return (
              <ul key={lang.langKey}>
                <li>
                  <SelectLanguageEn langs={this.props.langs} />
                </li>
                
                <li>
                <a href="http://www.ventacar.com.ni/" target="_blank"> 
                  Venta de autos
                 </a>
                 </li>

                <li>
                  <Link to={`/${lang.langKey}/faqs`}>Atención al cliente</Link>
                </li>
                <li>
                <a
                  className="whatsapp"
                  href="https://api.whatsapp.com/send?phone=50588561510"
                >
                  +505 8856-1510
                </a>
              </li>
                <li>
                  <a
                    className="btn btn-rounded phone-number"
                    href="tel:+50522559000"
                    onClick={() => this.handleGTMclick("tel:+50522559000")}
                  >
                     +505 2255-9000
                  </a>
                </li>
              </ul>
            )
          }
        })}
      </nav>
    )
  }
}

export default SecondNav;



// WEBPACK FOOTER //
// ./src/menus/SecondNav.js